if (!customElements.get('inno-sale-countdown')) {
 customElements.define('inno-sale-countdown', class extends HTMLElement {
  connectedCallback() {
   this.end = Date.parse(this.dataset.end);
   this.tick = () => {
    const left = this.end - Date.now();
    const values = this.querySelector('.inno-sale-values');
    const expired = this.querySelector('[data-expired]');
    if (!Number.isFinite(this.end)) { this.hidden = true; return; }
    this.hidden = false;
    if (left <= 0) { values.hidden = true; this.firstElementChild.hidden = true; expired.hidden = false; expired.textContent = this.dataset.ended; clearInterval(this.timer); return; }
    values.hidden = false; expired.hidden = true; this.firstElementChild.hidden = false;
    const seconds = Math.floor(left / 1000);
    const parts = { days: Math.floor(seconds/86400), hours: Math.floor(seconds/3600)%24, minutes: Math.floor(seconds/60)%60, seconds: seconds%60 };
    Object.entries(parts).forEach(([unit, value]) => { this.querySelector('[data-unit="'+unit+'"]').textContent = String(value).padStart(2,'0'); });
   };
   this.tick(); if(Number.isFinite(this.end) && this.end > Date.now()) this.timer = setInterval(this.tick,1000);
  }
  disconnectedCallback() { clearInterval(this.timer); }
 });
}
